import { Calendar } from 'lucide-react';
import { usePracticeStats } from '@/hooks/mindspace/usePracticeHistory';

/**
 * Compact "Today" summary chip - sessions, DISTINCT concepts practiced, and
 * minutes spent today, computed on the backend (distinct so repeated
 * no-stakes drills don't inflate the count). Hidden when nothing was
 * practiced today, since an all-zeros chip just adds noise.
 */
export function TodaySummary() {
  const { data } = usePracticeStats();
  const summary = {
    sessions: data?.today_sessions ?? 0,
    concepts: data?.today_concepts ?? 0,
    minutes: data?.today_minutes ?? 0,
  };

  if (summary.sessions === 0) return null;

  return (
    <div className='inline-flex items-center gap-2 rounded-full border border-border bg-card/80 px-3 py-1 text-xs text-muted-foreground dark:bg-card'>
      <Calendar className='h-3 w-3 text-muted-foreground' />
      <span className='font-medium text-muted-foreground'>Today</span>
      <span className='text-gray-300'>·</span>
      <span className='tabular-nums'>
        <strong className='font-semibold text-foreground'>
          {summary.sessions}
        </strong>{' '}
        {summary.sessions === 1 ? 'session' : 'sessions'}
      </span>
      <span className='text-gray-300'>·</span>
      <span className='tabular-nums'>
        <strong className='font-semibold text-foreground'>
          {summary.concepts}
        </strong>{' '}
        {summary.concepts === 1 ? 'concept' : 'concepts'}
      </span>
      {summary.minutes > 0 && (
        <>
          <span className='text-gray-300'>·</span>
          <span className='tabular-nums'>
            <strong className='font-semibold text-foreground'>
              {summary.minutes}
            </strong>
            m
          </span>
        </>
      )}
    </div>
  );
}
